



















































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "../../../lib/abpbase";
import Util from "../../../lib/util";
import TreeSelect from "@riophae/vue-treeselect";
import BillPeriodPo from "../../../store/entities/finance/billperiodpo";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import moment from "moment";

@Component({
  components: { TreeSelect },
})
export default class EditBillPeriod extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  billperiodPo: BillPeriodPo = new BillPeriodPo();

  created() {
    this.areaTree();
    this.billperiodPo.isEnable = 1;
  }
  create() { }
  save() {
    (this.$refs.billperiodForm as any).validate(async (valid: boolean) => {
      if (valid) {
        await this.$store.dispatch({
          type: "billperiod/update",
          data: this.billperiodPo,
        });
        (this.$refs.billperiodForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  cancel() {
    (this.$refs.billperiodForm as any).resetFields();
    this.$emit("input", false);
  }
  async areaTree() {
    await this.$store
      .dispatch("area/getAreaSelectTree")
      .then((val) => {
        this.$data.optionsMechanism = val;
      })
      .catch((err) => {
        console.log(err);
      });
  }
  handSelect(val: any) {
    if (this.billperiodPo.dayType == 3) {
      this.billperiodPo.firstBillDate = moment().startOf("month").toDate();
    } else if (this.billperiodPo.dayType == 2) {
      this.billperiodPo.firstBillDate = moment().endOf("month").toDate();
    }
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      this.billperiodPo = Util.extend(
        true,
        {},
        this.$store.state.billperiod.billPeriodItems
      );
    }
  }
  ruleValidate = {
    name: [
      {
        required: true,
        message: this.L("NameCanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    areaId: [
      {
        required: true,
        type: "number",
        message: this.L("Areas") + this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    dayType: [
      {
        required: true,
        type: "number",
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    firstBillDate: [
      {
        required: true,
        type: "date",
        message: this.L("FirstBillDate") + this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    monthNum: [
      {
        required: true,
        type: "number",
        message: this.L("MonthNum") + this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    lastPayNum: [
      {
        required: true,
        type: "number",
        message: this.L("LastPayNum") + this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    lateFee: [
      {
        required: true,
        type: "number",
        message: this.L("LateFee") + this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
  };
  data() {
    return {
      optionsMechanism: [],
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
    };
  }
}
